<template>
  <div class="wrap">
    <div class="login-box">
      <img class="logo" src="@/assets/images/logo-horizontal.png" />
      <div class="login-title">
        <template>
          <div class="tt">{{ title }}</div>
          <div class="tt-en" v-if="config.WEB == 2">EAGLE EYE CONTROL SYSTEM</div>
          <div class="tt-en" v-if="config.WEB == 3">MANAGEMENT AND CONTROL SYSTEM</div>
          <div class="tt-en" v-if="config.WEB == 4">LIYANG PARKING VR MANAGEMENT</div>
          <div class="tt-en" v-if="config.WEB == 5">YINGYAN COMPANY VR MANAGEMENT</div>
          <div class="tt-en" v-if="config.WEB == 7">CITY ENVIRONMENTAL VR MANAGEMENT</div>
          <div class="tt-en" v-if="config.WEB == 8 || config.WEB == 10">WATERS VR MANAGEMENT</div>
          <div class="tt-en" v-if="config.WEB == 11">ILLEGAL BUILDING VR MANAGEMENT</div>
        </template>
      </div>
      <div class="login-content">
        <div class="qrcode-box" v-loading="loading">
          <el-image v-if="unid" class="qrcode-img" :src="qrcode" fit="cover"></el-image>
          <div v-if="loginStatus == 1" class="mask login-success">
            <div class="txt">登录成功,跳转中...</div>
          </div>
          <div v-if="loginStatus == 2" class="mask login-failed">
            <div @click="getQrcode" class="txt">登录失败</div>
            <div @click="getQrcode" class="iconfont icon-refresh v-ml-5"></div>
          </div>
          <div v-if="loginStatus == 3" class="mask login-timeout">
            <div @click="getQrcode" class="txt">二维码失效</div>
            <div @click="getQrcode" class="iconfont icon-refresh v-ml-5"></div>
          </div>
        </div>
        <div v-if="config.ENV == 'development' || NODE_ENV == 'development'" style="color: red; text-align: center; cursor: pointer; margin-top: 2px" @click="isShowLogin = true">
          当前测试版，点击次处临时登录>>
        </div>
        <div class="wx-tip" v-else>
          <el-image class="icon" src="https://vybbasevr.vyb.cn/wx-logo2.png" fit="cover"></el-image>
          <div class="tip">请使用微信扫描二维码</div>
        </div>
      </div>
    </div>
    <div id="verificationBox"></div>
    <el-dialog v-if="isShowLogin" :visible="isShowLogin" width="300px" title="临时登录" @close="isShowLogin = false">
      <el-form>
        <el-form-item label="手机号码">
          <el-input v-model="mobile"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowLogin = false" size="small">取 消</el-button>
        <el-button type="primary" @click="login" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cookie from '../../api/cookie';

export default {
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      NODE_ENV: process.env.NODE_ENV,
      mobile: '',
      isShowLogin: false,
      unid: '',
      qrcode: '',
      loading: false,
      loginTimer: 0, //二维码登录轮询
      loginTimeTotal: 0, //二维码登录轮询
      loginStatus: 3, //1登录成功 2登录失败 3二维码失效
    };
  },

  created() {
    this.getQrcode();
  },

  methods: {
    //获取登录二维码
    async getQrcode() {
      this.loading = true;
      try {
        let res = await this.api.user.getLoginQrcode();
        this.qrcode = res.data.url;
        this.unid = res.data.unid;
        this.clearLoginTimer();
        this.setLoginTimer();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    clearLoginTimer() {
      clearTimeout(this.loginTimer);
      this.loginTimeTotal = 0;
      this.loginStatus = '';
    },

    //二维码登录轮询
    setLoginTimer() {
      this.loginTimeTotal += 1.5;
      if (this.loginTimeTotal < 5 * 60) {
        this.loginTimer = setTimeout(async () => {
          try {
            let res = await this.api.user.isLogin({ unid: this.unid });
            if (res.data.code == 1) {
              this.setLoginTimer();
            }

            if (res.data.code == 2) {
              this.clearLoginTimer();
              this.loginStatus = 1;
              cookie.setToken(res.data['xx-token']);
              this.$store.commit('user/SET_TOKEN', res.data['xx-token']);
              this.$router.replace('/front-vr-list');
            }
          } catch (e) {
            this.clearLoginTimer();
            this.loginStatus = 2;
          }
        }, 1500);
      } else {
        this.clearLoginTimer();
        this.loginStatus = 3;
      }
    },

    async login() {
      try {
        let res = await this.api.user.login({ login_name: this.mobile });
        this.clearLoginTimer();
        cookie.setToken(res.data['xx-token']);
        this.$store.commit('user/SET_TOKEN', res.data['xx-token']);
        this.$router.replace('/front-vr-list');
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wrap {
  height: 100vh;
  background: url('../../assets/images/login-bg.png') no-repeat center;
  background-size: cover;
  position: relative;
}

.login-box {
  width: 878px;
  height: 490px;
  position: absolute;
  border-radius: 6px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  background: #fff url('../../assets/images/login-box-bg.png') left center no-repeat;
  background-size: auto 100%;
}

.logo {
  position: absolute;
  display: block;
  top: 40px;
  left: 40px;
  width: 180px;
}

.login-title {
  position: absolute;
  top: 40px;
  left: 420px;
  text-align: center;
  width: 458px;

  .tt {
    font-size: 24px;
    font-weight: bold;
  }

  .tt-en {
    font-size: 18px;
    color: #999;
  }
}

.login-content {
  position: absolute;
  top: 138px;
  left: 480px;
  width: 354px;
}

.login-btn-box {
  margin-top: 50px;
}

input::-webkit-input-placeholder {
  font-size: 14px;
  color: #cacaca;
}

.login-btn {
  display: block;
  width: 100%;
  font-size: 16px;
  letter-spacing: 6px;
  background: linear-gradient(180deg, rgba(62, 144, 255, 1) 0%, rgba(21, 113, 238, 1) 100%);
  border-radius: 35px;
  border: 0;
  height: 50px;

  &:hover,
  &:focus {
    background: linear-gradient(180deg, rgba(62, 144, 255, 1) 0%, rgba(21, 113, 238, 1) 100%);
  }
}

.login-mode {
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
}

.login-mode .icon {
  display: block;
  width: 34px;
  height: 34px;
}

.login-mode .icon-computer {
  font-size: 30px;
  color: #d6d6d6;
}

#verificationBox /deep/ .yp-riddler-winbox {
  margin-top: -125px;
  top: 50%;
  position: relative;
}

.login-box /deep/ .form-control .el-input__inner {
  border-width: 0;
  border-radius: 20px;
  padding-left: 30px;
  height: 50px;
  background: #f6f6f6;
}

.qrcode-box {
  position: relative;
  border: 1px solid #eee;
  width: 280px;
  height: 280px;
  margin: 0 auto;
}

.qrcode-img {
  display: block;
  width: 100%;
  height: 100%;
}

.qrcode-box .mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-box .mask .txt {
  cursor: pointer;
}

.qrcode-box .mask .iconfont {
  cursor: pointer;
}

.wx-tip {
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: center;
  margin-top: 10px;
}

.wx-tip .icon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
</style>
